// src/frontend/data/books/BlockchainFundamentals/data/cap10.js

const CAP11 = {
  id: 10,
  slug: "cap10-dogecoin-doge",
  title: "Capítulo 10 — Dogecoin (DOGE): la memecoin que se volvió fenómeno global",
  sections: [
    {
      heading: "¿Qué es Dogecoin (DOGE)?",
      text: [
        "Dogecoin (DOGE) es un fenómeno cripto muy curioso: una criptomoneda creada como broma que terminó convirtiéndose en una de las monedas más famosas del mundo.",
        "Es la meme coin (o ‘dog coin’) por antonomasia, cuyo éxito sorprendió incluso a sus creadores.",
        "Su historia demuestra que en cripto no solo importa la tecnología: la cultura, la comunidad y el contexto social también pueden impulsar la adopción y el valor."
      ]
    },

    // ===== Origen meme =====
    {
      heading: "El origen del meme: Kabosu y la cultura de Internet",
      text: [
        "La imagen pública de Dogecoin es el meme de una perra Shiba Inu conocida como ‘Kabosu’.",
        "Kabosu era propiedad de una profesora de jardín de infancia japonesa llamada Atsuko Satō.",
        "Satō comenzó un blog en 2010 contando la vida con sus mascotas y familia, sin imaginar que una foto se volvería viral a escala mundial."
      ]
    },
    {
      heading: "4chan vs Reddit: una guerra de memes",
      text: [
        "La fama del meme explotó cuando una imagen de Kabosu fue usada por un grupo de ‘anons’ de 4chan en un ataque de spam contra un hilo en Reddit (r/Murica).",
        "El episodio se recuerda como una de las grandes ‘guerras’ entre comunidades de 4chan y Reddit.",
        "En ese clima cultural nació la idea: convertir el meme en una criptomoneda."
      ]
    },

    // ===== Creación DOGE =====
    {
      heading: "Creación de Dogecoin: una broma que se salió de control",
      text: [
        "Casi al mismo tiempo, dos programadores decidieron llevar el meme a otro nivel: convertirlo en el corazón de una criptomoneda.",
        "La intención era doble: continuar la ‘guerra de memes’ y burlarse de la fiebre de criptomonedas que crecía en Internet.",
        "Así, Billy Markus (ex trabajador de IBM) y Jackson Palmer (australiano, ligado al marketing de Adobe Systems) comenzaron el proyecto."
      ]
    },
    {
      heading: "Lanzamiento: 6 de diciembre de 2013",
      text: [
        "Dogecoin se lanzó el 6 de diciembre de 2013.",
        "La moneda se popularizó rápidamente en foros, especialmente en 4chan, donde la comunidad la recibió con humor.",
        "Lo inesperado fue que la capitalización creció de forma explosiva: se menciona un aumento de alrededor de 300% en solo 15 días."
      ]
    },

    // ===== Evolución y especulación =====
    {
      heading: "Un crecimiento inesperado impulsado por comunidad y especulación",
      text: [
        "Con el tiempo, Dogecoin vivió ciclos de crecimiento y caída muy ligados a olas de atención mediática.",
        "El proyecto demostró que una comunidad fuerte puede sostener una narrativa durante años, incluso con pocas mejoras técnicas.",
        "Esto también abrió el debate sobre si Dogecoin es una criptomoneda ‘seria’ o una broma muy cara."
      ]
    },

    // ===== Tecnología base =====
    {
      heading: "¿Cómo funciona Dogecoin? (base técnica)",
      text: [
        "Dogecoin nació como un fork del código de Litecoin.",
        "Por eso, usa Proof of Work (PoW) con el algoritmo de hash scrypt.",
        "Además, puede aprovechar ‘merged mining’, una técnica que permite minar junto con otra red compatible, aumentando seguridad."
      ]
    },
    {
      heading: "Parámetros técnicos destacados",
      list: [
        "Consenso: Proof of Work (PoW).",
        "Algoritmo: scrypt (heredado del mundo Litecoin).",
        "Tiempo por bloque: alrededor de 1 minuto.",
        "Emisión por bloque: históricamente alta (comúnmente se menciona ~10.000 DOGE por bloque).",
        "Emisión total: ilimitada (no hay máximo como en Bitcoin)."
      ]
    },
    {
      heading: "Emisión infinita: ¿por qué importa?",
      text: [
        "A diferencia de Bitcoin (21 millones), Dogecoin tiene emisión ilimitada.",
        "Esto significa que siempre se crean nuevas monedas, lo que suele considerarse inflacionario.",
        "En momentos de ‘hype’, esa emisión puede ser ignorada por el mercado; en periodos largos, puede presionar el precio si no hay demanda suficiente."
      ]
    },

    // ===== Desarrollo y roadmap =====
    {
      heading: "¿Dogecoin innova tecnológicamente?",
      text: [
        "Una crítica frecuente es que Dogecoin no tiene un roadmap fuerte de innovación y que gran parte de sus mejoras históricas han venido como adaptaciones de avances de Bitcoin o Litecoin.",
        "Aun así, Dogecoin ha mantenido su red en funcionamiento y su seguridad por la minería y su base técnica heredada."
      ]
    },

    // ===== Wallets =====
    {
      heading: "Wallets y almacenamiento",
      text: [
        "Como otras criptomonedas, Dogecoin puede guardarse en distintos tipos de wallets.",
        "Existen wallets de software, wallets en línea y hardware wallets para mayor seguridad."
      ]
    },
    {
      heading: "Tipos de wallets soportadas",
      list: [
        "Software wallets: Dogecoin Core (puede descargar la blockchain completa) y MultiDoge (más liviana).",
        "Wallets en línea: plataformas que custodian fondos y facilitan compra/venta (requieren confianza).",
        "Hardware wallets: dispositivos como Ledger y Trezor que almacenan llaves sin exponerlas a Internet."
      ]
    },

    // ===== Comunidad / Elon Musk =====
    {
      heading: "La comunidad: el verdadero motor de Dogecoin",
      text: [
        "Dogecoin se convirtió en un caso único porque desarrolló una comunidad intensa y emocionalmente conectada.",
        "Ese factor cultural fue central para su supervivencia y ciclos de renacimiento.",
        "Muchos defensores argumentan que la comunidad es su mayor ‘fundamental’."
      ]
    },
    {
      heading: "Elon Musk y el ‘efecto tweet’",
      text: [
        "Una de las excentricidades más conocidas de Dogecoin es su vínculo mediático con Elon Musk.",
        "Sus publicaciones han sido asociadas con movimientos fuertes de precio, reforzando la idea de que DOGE es extremadamente sensible a narrativa y especulación.",
        "Esto alimenta tanto el entusiasmo como las críticas, ya que evidencia volatilidad social."
      ]
    },

    // ===== Curiosidades / caridad =====
    {
      heading: "Curiosidades: Dogecoin y la cultura de la caridad",
      text: [
        "Dogecoin también se hizo famosa por su espíritu comunitario y acciones caritativas.",
        "Un caso muy conocido es el apoyo para financiar el viaje del equipo jamaiquino de bobsleigh a los Juegos Olímpicos de Invierno en 2014, con una recaudación aproximada de más de US$ 30.000.",
        "El contraste fue memorable: un meme financiero financiando un evento deportivo improbable."
      ]
    },

    // ===== Reflexión =====
    {
      heading: "¿Dogecoin es una criptomoneda real o solo una broma?",
      text: [
        "Para algunos, Dogecoin dejó de ser una broma porque tiene blockchain funcional, minería activa y una comunidad enorme.",
        "Para otros, el problema es que no innova y depende demasiado de atención mediática.",
        "La realidad es que Dogecoin se convirtió en un experimento social: prueba de que narrativa + comunidad pueden convertir un chiste en un activo global."
      ]
    },

    // ===== Buenas prácticas =====
    {
      heading: "Buenas prácticas si vas a usar DOGE",
      list: [
        "Entiende que es una moneda muy influida por especulación y redes sociales.",
        "Evita comprar por ‘FOMO’ (miedo a quedarte fuera).",
        "Usa wallets confiables y respalda tu seed (frase de recuperación).",
        "Si vas a enviar DOGE, verifica dirección y red, y prueba primero con una cantidad pequeña.",
        "No confundas popularidad con baja volatilidad: DOGE puede moverse muy rápido."
      ]
    },

    // ===== Cierre =====
    {
      heading: "Conclusión",
      text: [
        "Dogecoin es el ejemplo más famoso de cómo Internet puede crear valor alrededor de cultura y comunidad.",
        "Nació como una sátira, pero se transformó en una criptomoneda con presencia global.",
        "Su historia ayuda a entender que el mundo cripto no es solo tecnología: también es psicología, narrativa y comportamiento social."
      ]
    }
  ]
};

export default CAP11;
